export {default as create} from "./src/create";
export {default as creator} from "./src/creator";
export {default as local} from "./src/local";
export {default as matcher} from "./src/matcher";
export {default as mouse} from "./src/mouse";
export {default as namespace} from "./src/namespace";
export {default as namespaces} from "./src/namespaces";
export {default as clientPoint} from "./src/point";
export {default as select} from "./src/select";
export {default as selectAll} from "./src/selectAll";
export {default as selection} from "./src/selection/index";
export {default as selector} from "./src/selector";
export {default as selectorAll} from "./src/selectorAll";
export {styleValue as style} from "./src/selection/style";
export {default as touch} from "./src/touch";
export {default as touches} from "./src/touches";
export {default as window} from "./src/window";
export {event, customEvent} from "./src/selection/on";



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/index.js
// module id = 18
// module chunks = 0